import { formatNumberValue, fromEventTarget } from '@/utils'
import { pipe } from 'ramda'
import { Input } from '../../styled'
import { handleKeyDown, replaceAllComas } from './helpers'

export interface NumberInputBaseProps {
  value: number | string
  onChange: (value: number | string) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  error?: boolean
  disabled?: boolean
}

export const NumberInputBase = ({
  value,
  onChange,
  onBlur,
  error,
  disabled,
  ...props
}: NumberInputBaseProps) => {
  const handleChange = fromEventTarget(pipe(replaceAllComas, onChange))

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (value !== '') onChange(parseFloat(replaceAllComas(e.target.value)))
    onBlur?.(e)
  }

  return (
    <Input
      disabled={disabled}
      error={error}
      inputMode="numeric"
      onBlur={handleBlur}
      onChange={handleChange}
      value={formatNumberValue(value)}
      {...props}
      onKeyDown={handleKeyDown}
    />
  )
}
